import { render, staticRenderFns } from "./PadMenu.vue?vue&type=template&id=78b54416&scoped=true&"
import script from "./PadMenu.vue?vue&type=script&lang=ts&"
export * from "./PadMenu.vue?vue&type=script&lang=ts&"
import style0 from "./PadMenu.vue?vue&type=style&index=0&id=78b54416&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b54416",
  null
  
)

export default component.exports